import { VERIFICATION_METHOD } from '../../domain/domainCodes.js'
/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const companiesStrings = {
  title: 'Companies List',
  panel: 'Company Management',

  columns: {
    arabicName: 'Arabic name',
    englishName: 'English name',
    isActive: 'Active',
    users: 'Users',
    profile: 'Company Profile',

    email: 'Email',
    registeredOn: 'Registration date',
  },

  loadFailed: 'The organisations could not be loaded',

  active: 'Active',
  inactive: 'Inactive',
  viewUsers: 'Users',
  viewProfile: 'Profile',
  delete: 'Delete',
  deleteConfirm: 'Are you sure you want to remove this item?',
  yes: 'Yes',
  no: 'No',
  close: 'Close',
  deleted: 'Operation Completed Successfully',
  deleteFailed: 'Operation Failed',

  usersModal: {
    title: 'Users',
    index: 'ID',
    username: 'Username',
    arabicName: 'Arabic Name',
    englishName: 'English Name',
    email: 'The email',
    empty: 'No users in this organisation',
  },
}

export const licenseManagementStrings = {
  saveUnavailable: 'Saving a licence is not available yet — no service accepts this data.',
  title: 'License Management',
  panel: 'License Management',
  create: 'Create',

  summary: {
    clients: 'Clients',
    seats: 'Total seats',
    live: 'Active licenses',
  },

  save: 'Save',
  emptyMessage: 'There is no companies with licence',

  columns: {
    company: 'Company',
    licenseType: 'Licesne Type',
    usersNumber: 'User Number',
    startDate: 'Start Date',
    duration: 'Duration',
  },

  form: {
    company: 'Company',
    passKey: 'Password',
    startDate: 'Start Date',
    licenseType: 'Licesne Type',
    usersNumber: 'User Number',
    duration: 'Duration',
    minMaxUsers: 'Users Count must be between 1 and 9999999',
    minMaxDuration: 'Duration must be between 1 and 9999999 days',
  },

  typeFields: {
    [VERIFICATION_METHOD.OPEN]: { users: false, duration: false },
    [VERIFICATION_METHOD.CLOSE]: { users: false, duration: false },
    [VERIFICATION_METHOD.TIME_STAMP]: { users: false, duration: true },
    [VERIFICATION_METHOD.NUMBER_OF_USERS]: { users: true, duration: false },
    [VERIFICATION_METHOD.NUMBER_OF_USERS_AND_TIME_STAMP]: { users: true, duration: true },
  },

  edit: 'Update',
  close: 'Close',
  saved: 'Operation Completed Successfully',

  saveFailed: 'تعذر الحفظ، فضلا حاول مرة أخرى' /* !! */,
}

export const companyProfileStrings = {
  saveFailed: 'The operation could not be completed',

  // The screen had no failure path at all — see the note in CompanyProfilePage.
  errorHeading: 'Error',
  loadFailed: 'The organization profile could not be loaded',
  title: 'Company Profile',
  subtitle: 'Update',

  sections: {
    identity: 'Organization identity',
    contact: 'Contact details',
    access: 'Sign-in and registration',
  },

  englishName: 'English Name',
  arabicName: 'Arabic Name',
  email: 'Company Email',
  supportEmail: 'Support Email',
  supportPhone: 'Support Phone',
  authMethod: 'Authentication Method',
  licenseType: 'License Method',
  activation: 'Activations',
  byEmail: 'By Email',
  byAdmin: 'By Admin',
  emailOnDomain: 'Email Should be on Domain',
  domains: 'Company Domain',
  registerLinkLabel: 'Copy Registration Link',
  registerLink: 'Registration',
  update: 'Update',
  close: 'Close',
  saved: 'Operation Completed Successfully',
}

export const licenseInformationStrings = {
  title: 'License Information',
  subtitle:
    'You can find all your related license Information below',
  current: 'Current Active License Details',
  previous: 'License History',
  renew: 'License Renewal',
  licenseFile: 'License File',
  save: 'Save',

  fields: {
    company: 'Company',
    licenseType: 'Licence Type',
    startDate: 'Start Date',
    duration: 'Duration',
    daysLeft: 'Remaining Days',
    expirationDate: 'End Date',
    accounts: 'Accounts',
    consumedAccounts: 'Consumed Accounts',
    remainingAccounts: 'Remaining Accounts',
  },

  elapsed: 'Days elapsed',

  history: {
    licenseType: 'Licence Type',
    startDate: 'Start Date',
    duration: 'Duration',
    accounts: 'Accounts',
  },

  unavailable: '—',
}
